import React, { Component } from 'react';
import TableRowEdit from './TableRowEdit.jsx';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper.js';

/**
 * Funcion que devuelve un componente que representa la cabecera de la fila
 * @param {any} props Objeto que contiene todas las propiedades utilizadas por el encabezado
 */
const HeadRow = (props) => {
    let nombre = props.tarjeta.ClienteApellido ? props.tarjeta.ClienteNombre + " " + props.tarjeta.ClienteApellido : props.tarjeta.ClienteNombre;

    return (<div className="col-xs-4">
        <div className="row">
            <div className="col-xs-4"></div>
            <div className="col-xs-8 no-padding-right no-padding-left">
                {props.tarjeta.hasOwnProperty("cursive") ?
                    <i><label className="label-secondary">{nombre}</label></i>
                    : <i><label className="label-secondary">{nombre}</label></i>}
            </div>
        </div>
    </div>);
};

/**
 * Funcion que devuelve un componente que representa el cuerpo de la fila
 * @param {any} props Objeto que contiene todas las propiedades utilizadas por el cuerpo
 */
const BodyRow = (props) => {
    let esNovedad = false;
    let novedad = {};
    let limite = 0;
    let limiteAnterior = 0;
    const { tarjeta, novedades, valorCuenta, modalidadDistribucionLimiteId, cuentaId, cambiarLimite, limiteCompraTotal, seEstaEditando } = props.data;
    //limiteCompraTotal: utilizada solamente si modalidad de distribucion de limite es 1 ya que en esa instancia no debe superar el 100% las tarjetas
    if (novedades.length > 0) {
        novedad = novedades.find((n) => { return n.TarjetaCreditoId == tarjeta.Id });
        if (novedad) {
            esNovedad = true;
            limite = GlobalHelper.ParseFloat(novedad.ValorNovedad);
            limiteAnterior = GlobalHelper.ParseFloat(novedad.ValorNovedad);
        } else {
            limite = tarjeta.PorcentajeLimiteCompra;
            limiteAnterior = tarjeta.limiteAnterior;
        }
    } else {
        limite = tarjeta.PorcentajeLimiteCompra;
        limiteAnterior = tarjeta.limiteAnterior;
    }


    if (props.seEstaEditando == true) {
        return <TableRowEdit
            tarjetaId={tarjeta.Id}
            limite={limite}
            limiteAnterior={limiteAnterior}
            modalidadDistribucionLimiteId={modalidadDistribucionLimiteId}
            cuentaId={cuentaId}
            cambiarModoEdicion={props.cambiarModoEdicion}
            mostrarMensajeLimitesIguales={props.mostrarMensajeLimitesIguales}
            cambiarLimite={props.cambiarLimite}
            limiteCompraTotal={limiteCompraTotal} />
    } else {
        let row;

        if (modalidadDistribucionLimiteId > 1) {
            row = <div className="col-xs-3 container-distribution-with-pencil">
                <label className="label-secondary color-azul-claro">{limite + " %"}</label>
                <label className="label-secondary left-separator-xxs">{"$ " + GlobalHelper.ConvertirNumeroMilesMillones(valorCuenta)}</label>
            </div>
        }
        else {
            row = <div className="col-xs-3">
                <label className="label-secondary left-separator-xxs">SIN LIMITES</label>
            </div>
        }

        return (<div className="col-xs-8">
            <div className="row" onClick={() => {
                //seEstaEditando => refiere al estado general de distribucion de limites y no a una tarjeta particular
                if (modalidadDistribucionLimiteId > 1 && seEstaEditando == false) {
                    props.cambiarModoEdicion(true)
                } else {
                    return false;
                }
            }}>
                {row}
            </div>
            {props.children}
        </div>);
    }
};

/**
 * Funcion que devuelve un componente que representa una novedad
 * @param {any} props Objeto que contiene todas las propiedades utilizadas por la novedad
 */
const NovedadRow = (props) => {
    let novedad = undefined;

    if (props.novedades.length > 0) {
        novedad = props.novedades.find((n) => { return n.TarjetaCreditoId == props.tarjeta.Id });
    }

    if (novedad) {
        let valorAnterior = GlobalHelper.ConvertirNumeroMilesMillones(novedad.ValorAnterior);
        let fechaModificacion = novedad.FechaHoraModificacion.replace("T", " ").replace("Z", "");
        let fecha = fechaModificacion.substring(0, 10).split("-");
        let hora = fechaModificacion.substring(16, 11);
        let mensaje = "Editado el " + fecha[2] + " - " + fecha[1] + " a las "
            + hora + " por " + novedad.UsuarioLoginModificacion + ". Era " + valorAnterior + "%."

        if (novedad) {
            return (<div className="row">
                <div className="col-xs-12">
                    {(props.mensajeEdicion == true)
                        ? <div>
                            <sub><i>{mensaje}</i></sub>
                            <a onClick={() => { props.mostrarMensaje(false) }} className="clickable"><sub><ins><i>Cerrar</i></ins></sub></a>
                        </div>
                        : <a onClick={() => { props.mostrarMensaje(true) }} className="clickable"><sub><ins><i>Editado</i></ins></sub></a>}
                </div>
            </div>);
        }
    } else {
        return null;
    }
};
/**
 * Clase encargada de crear las filas en modo solo lectura
 */
class TableRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mensajeEdicion: false,
            seEstaEditando: false
        };
    }

    componentWillReceiveProps(nextProps) {
        //this.state.seEstaEditando = false;
    }
    /**
     * Cambia el estado de la fila indicando si se debe mostrar el mensaje descriptivo de su edicion
     * @param {any} valor Parametro booleano
     */
    mostrarMensaje(valor) {
        this.setState({ mensajeEdicion: valor });
    }
    /**
     * 
     * @param {any} activado
     */
    cambiarModoEdicion(activado) {
        this.setState({ seEstaEditando: activado },
            this.props.cambiarModoEdicion(activado));
    }

    cambiarLimite(tarjetaId, limite, seleccionarTodasAsig, cuentaId) {
        this.setState({ seEstaEditando: false },
            this.props.cambiarLimite(tarjetaId, limite, seleccionarTodasAsig, cuentaId));
    }

    mostrarMensajeLimitesIguales(estado) {
        this.props.mostrarMensajeLimitesIguales(estado);
    }

    render() {
        return (
            <div className="row bottom-separator-xxs no-margin-right">
                <HeadRow tarjeta={this.props.tarjeta} />
                <BodyRow data={this.props}
                    seEstaEditando={this.state.seEstaEditando}
                    cambiarModoEdicion={(valor) => this.cambiarModoEdicion(valor)}
                    cambiarLimite={(tarjetaId, limite, seleccionarTodasAsig, cuentaId) => {
                        this.cambiarLimite(tarjetaId, limite, seleccionarTodasAsig, cuentaId)
                    }}
                    mostrarMensajeLimitesIguales={(estado) => this.mostrarMensajeLimitesIguales(estado)}>

                    <NovedadRow tarjeta={this.props.tarjeta} novedades={this.props.novedades}
                        mensajeEdicion={this.state.mensajeEdicion}
                        mostrarMensaje={(valor) => { this.mostrarMensaje(valor) }} />
                </BodyRow>
            </div>
        );
    }
}

export default TableRow;